import { ReactNode } from 'react';

type StatCardProps = {
  label: string;
  value: string | number;
  detail: string;
  accent?: 'gold' | 'teal' | 'rose' | 'ink';
  icon?: ReactNode;
};

export function StatCard({ label, value, detail, accent = 'gold', icon }: StatCardProps) {
  return (
    <article className={`stat-card stat-card-${accent}`}>
      <div className="stat-card-header">
        <span className="stat-label">{label}</span>
        {icon ? <span className="stat-icon">{icon}</span> : null}
      </div>
      <strong className="stat-value">{value}</strong>
      <p className="stat-detail">{detail}</p>
    </article>
  );
}
